<template>
    <v-tab-item :value="GENRE.value">
        <div class="page-section-wrap">
            <section class="page-section">
                <div class="mb-20 mb-md-30">
                    <v-row>
                        <v-col cols="12" lg="6">
                            <h2 class="tit">프라이빗 세일(Private Sales) 장르</h2>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <h3 class="tit tit--sm line-height-14">프라이빗 세일의 장르(카테고리)는 7개 부문입니다. <br class="d-none d-md-block" />주로 현대미술 및 고미술 등 미술품 중심으로 구성되었습니다.</h3>
                        </v-col>
                    </v-row>
                </div>
                <private-genre-banner />
            </section>

            <section class="page-section">
                <v-row>
                    <v-col cols="12" lg="6">
                        <h2 class="tit">출품 조건</h2>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <div class="pb-16 pb-md-24">
                            <div class="mb-10">
                                <h4 class="tit tit--xs">작가 기준</h4>
                            </div>
                            <div>
                                <p class="page-text">프라이빗 세일에는 1국내외 근현대 대표작가 및 2Emerging Artist를중심으로 출품 됩니다.</p>
                            </div>
                        </div>
                        <v-divider class="grey-cb"></v-divider>
                        <div class="py-16 py-md-24">
                            <div class="mb-10">
                                <h4 class="tit tit--xs">작품 기준</h4>
                            </div>
                            <div>
                                <p class="page-text">프라이빗 세일에는 &lt;상태등급&gt; 및 &lt;가치 등급&gt;이 B등급 이상인 작품을 출품합니다.</p>
                            </div>
                        </div>
                        <v-divider class="grey-cb"></v-divider>
                        <div class="pt-16 pt-md-24">
                            <div class="mb-10">
                                <h4 class="tit tit--xs">진품 보증</h4>
                            </div>
                            <div>
                                <p class="page-text">프라이빗 세일에는 &lt;진품이 보증&gt;된 작품만 출품됩니다.</p>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="mt-10 mt-lg-20">
                            <v-simple-table class="v-simple-table v-data-table--none-active-bg v-data-table--default text-center">
                                <thead>
                                    <tr>
                                        <th>작가 기준</th>
                                        <th>작품 기준</th>
                                        <th>제공 서류</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div class="page-text primary--text">
                                                <p>- 근대 대표작가</p>
                                                <p>- 현대 대표작가</p>
                                                <p>- Emerging Artist</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="page-text primary--text">
                                                <p>- 작품 상태등급 : B급 이상</p>
                                                <p>- 작품 가치등급 : B급 이상</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="page-text primary--text">
                                                <p>- 상태검사서</p>
                                                <p>- 작품이력서</p>
                                                <p>- 작품설명서</p>
                                                <p>- 출품확인서</p>
                                                <p>- 진품보증서(감정기관, 작가)</p>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <div class="page-text">
                            <p style="letter-spacing:-.04em!important;">※ 제공 서류 : 프라이빗 세일에 출품된 작품의 구매자에게는 다음의 5가지 서류가 제공됩니다.</p>
                            <p>※ 작품 가치등급은 캐터옥션 &lt;가치등급 기준표&gt;를 적용하여 부여합니다.</p>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <div class="mt-n16 mt-md-n20 mt-lg-0">
                            <p class="page-text">※ 작품 판매시, 대금지불 및 운송 등의 내용은, 경매작품과 동일하게 적용되며, <br class="d-none d-md-block" />자세한 사항은 다음을 참조하시기 바랍니다.</p>
                            <div class="mt-4">
                                <v-btn small text height="auto" color="grey-68" to="/" class="pa-0 v-btn--none-active-bg"><strong>자세히보기</strong><v-icon>mdi-menu-right</v-icon></v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </section>
        </div>
    </v-tab-item>
</template>

<script>
import { PRIVATE_SALES_TABS } from "@/assets/variables";
import privateGenreBanner from "./private-genre-banner.vue";
const { GENRE } = PRIVATE_SALES_TABS;
export default {
    components: { privateGenreBanner },
    data() {
        return {
            GENRE,
        };
    },
};
</script>

<style></style>
